"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestBubble = void 0;
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const GuestAvatar_1 = require("./avatars/GuestAvatar");
const GuestBubble = ({ message }) => {
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { classNames: "bubble", timeout: 1000 },
        react_1.default.createElement("div", { className: "flex justify-end mb-2 items-center" },
            react_1.default.createElement("div", { className: "flex items-end w-11/12 lg:w-4/6 justify-end" },
                react_1.default.createElement("div", { className: "inline-flex px-4 py-2 rounded-lg mr-2 whitespace-pre-wrap max-w-full typebot-guest-bubble" }, message),
                react_1.default.createElement("div", { className: "flex w-6 h-6 xs:h-10 xs:w-10 mr-2 flex-shrink-0 items-center mb-1 xs:mb-0" },
                    react_1.default.createElement(GuestAvatar_1.GuestAvatar, null))))));
};
exports.GuestBubble = GuestBubble;
//# sourceMappingURL=GuestBubble.js.map